import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import React, {useEffect, useState} from "react";
import {Form, Formik} from "formik";
import ModalBody from "react-bootstrap/ModalBody";
import * as Yup from "yup";
import {getICDx} from "../../laporan/DataProvider";
import Async from "react-select/async/dist/react-select.esm";
import {InputAlert} from "../../component/InputAlert";
import AsyncSelect from "react-select/async";
import API from "../../../apiService";
import ModalFooter from "react-bootstrap/ModalFooter";
import apiService from "../../../apiService";
import Alert from "../../component/Alert";
import Select from "react-select";

const ReportTypeSchema = Yup.object().shape({
    // name: Yup.string().required("Nama harus diisi"),
})

export default function ClinicTreatmentModal(props) {

    const [clinic, setClinic] = useState({})
    const [treatments, setTreatments] = useState([])
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        if (props.editeddata) {
            setClinic(props.editeddata.clinic)
            setTreatments(props.editeddata.treatments)
        }
    }, [props.editeddata])

    const resetData = () => {
        setClinic({})
        setTreatments([])
    }

    const handleSubmit = () => {
        if (props.editeddata) {
            update()
        }
        else {
            create()
        }
    }

    const update = async () => {
        try {
            let response = await API.post("/management/clinic-treatment/create", {
                clinic_id: clinic.value,
                treatment_id: treatments.map(v => v.value)
            })

            if (response.code === 200) {
                props.onHide()
                props.reloaddata()
                Alert("success", "Data berhasil diedit")
                resetData()
            }
            else {
                console.log(response)
                Alert("error", "Gagal mengedit data. Coba lagi.")
            }
        }
        catch (e) {
            console.log(e)
            Alert("error", "Gagal mengedit data. Coba lagi.")
        }
    }

    const create = async () => {
        try {
            let response = await API.post("/management/clinic-treatment/create", {
                clinic_id: clinic.value,
                treatment_id: treatments.map(v => v.value)
            })

            props.onHide()
            props.reloaddata()
            Alert("success", "Data berhasil ditambahkan")
            resetData()
        }
        catch (e) {
            console.log(e)
            Alert("error", "Gagal menambahkan data. Coba lagi.")
        }
    }

    const loadOptions = async (inputValue, callback) => {
        try {
            const res = await API.get(`management/treatments/read?keyword=${inputValue}`)
            console.log(res)
            if (res.code === 200) {
                callback(res.data.map(v => ({value: v.id, label: v.name})))
            }
        }
        catch (e) {
            callback([])
            console.log(e)
        }
    }

    return (
        <Modal
            {...props}
            aria-labelledby="modal-user"
            onHide={() => {
                props.onHide()
                resetData()
            }}
        >
            <ModalHeader closeButton>
                <ModalTitle>
                    <h3>{props.editeddata ? 'Edit' : 'Tambah'} Data Kelompok Tindakan</h3>
                </ModalTitle>
            </ModalHeader>
            <Formik
                enableReinitialize
                initialValues={{
                }}
                validationSchema={ReportTypeSchema}
                onSubmit={values => {
                    handleSubmit()
                }}
            >
                {({ values, errors, touched }) => (
                    <Form>
                        <ModalBody>
                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-4 col-form-label col-form-label-sm"
                                >
                                    Klinik
                                </label>
                                <div className="col-md-8">
                                    <Select
                                        cacheOptions
                                        options={props.refclinics}
                                        value={clinic}
                                        onChange={e => {
                                            setClinic(e)
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label
                                    htmlFor="example-text-input"
                                    className="col-md-4 col-form-label col-form-label-sm"
                                >
                                    Tindakan
                                </label>
                                <div className="col-md-8">
                                    <AsyncSelect
                                        cacheOptions
                                        loadOptions={loadOptions}
                                        defaultOptions
                                        isMulti
                                        onInputChange={v => {
                                            const i = v.replace(/\W/g, '')
                                            setInputValue(i)
                                            return i
                                        }}
                                        value={treatments}
                                        onChange={e => {
                                            console.log(e)
                                            setTreatments(e || [])
                                        }}
                                    />
                                </div>
                            </div>

                            <hr/>


                        </ModalBody>
                        <ModalFooter>
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        type="submit"
                                        className="btn btn-outline-secondary"
                                        onClick={() => {
                                            props.onHide()
                                        }}
                                    >
                                        Batal
                                    </button>
                                    <button
                                        onClick={handleSubmit}
                                        type="button"
                                        className="btn btn-primary">
                                        Simpan
                                    </button>
                                </div>
                            </div>
                        </ModalFooter>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}